import httpService from "./httpService";

export interface UserAccountSummary {
  grantId: string;
  userId: string;
  email: string;
  ibkrAccountId: string | null;
  name: string | null;
  image: string | null;
  approvedAtUtc: string;
}

export interface GetAccountsResponse {
  list: UserAccountSummary[];
  userId: string;
  effectiveUserId: string;
}

export interface ActivateAccountResponse {
  accessToken: string;
  refreshToken: string;
  account: UserAccountSummary;
}

export interface AccountContextRequestOptions {
  requestScope?: "actor" | "account-transition" | "session-transition";
}

const userAccountContextService = {
  getAccounts: async (
    options?: AccountContextRequestOptions
  ): Promise<GetAccountsResponse> => {
    const response = await httpService.get<GetAccountsResponse>("/v3/accounts", {
      requestScope: options?.requestScope ?? "actor",
    });
    return response.data;
  },

  activateAccount: async (
    targetUserId: string,
    options?: AccountContextRequestOptions
  ): Promise<ActivateAccountResponse> => {
    const normalizedTargetUserId = targetUserId.trim();
    if (!normalizedTargetUserId) {
      throw new Error("Target user ID is required");
    }

    const response = await httpService.post<ActivateAccountResponse>(
      `/v3/accounts/${encodeURIComponent(normalizedTargetUserId)}/activate`,
      undefined,
      { requestScope: options?.requestScope ?? "actor" }
    );
    return response.data;
  },
};

export default userAccountContextService;
